export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === '') return '';
  
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

export const parseCurrency = (value) => {
  if (!value) return 0;
  const number = value.replace(/[^0-9]/g, '');
  return parseInt(number, 10) || 0;
};